import { TenantPerm } from '@enum/tenant/permission/tenant-perm.enum';

export const AccountSection = [
  {
    section: 'Contabilidade',
    permission: [
      '*',
      TenantPerm.AccountingDocuments_View,
      TenantPerm.FiscalRps_View,
      TenantPerm.AccountingSheets_View,
      TenantPerm.AccountingReports_View,
    ],
  },
  {
    title: 'Documentos',
    permission: ['*', TenantPerm.AccountingDocuments_View],
    root: true,
    icon: 'description',
    page: '/painel/financas/documentos',
    bullet: 'dot',
  },
  {
    title: 'Notas fiscais',
    permission: ['*', TenantPerm.FiscalRps_View],
    root: true,
    // Era 'receipt_long' — repetia com "Contas a pagar" (dono, 22/09/2026:
    // ícone único por item do menu). `request_page` é o documento fiscal
    // oficial; "Contas a pagar" fica com `receipt_long`.
    icon: 'request_page',
    page: '/painel/fiscal/notas',
    bullet: 'dot',
  },
  {
    title: 'Planilha contábil',
    permission: ['*', TenantPerm.AccountingSheets_View],
    root: true,
    icon: 'table_chart',
    page: '/painel/financas/planilha-contabil',
    bullet: 'dot',
  },
  {
    title: 'Relatórios',
    permission: ['*', TenantPerm.AccountingReports_View],
    root: true,
    icon: 'show_chart',
    page: '/painel/financas/relatorios',
    bullet: 'dot',
  },
];
